import { AppBar, Grid, Toolbar } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import React from "react"

const Cabecalho = (props) => {
	const classes = useStyles()

	return (
		<AppBar position="absolute" className={classes.appBar}>
			<Toolbar className={classes.toolbar} >
				<Grid container className={classes.gridContainer} direction='row' alignItems='center' justifyContent="space-between">
					{props.left}
					{props.right}
				</Grid>
			</Toolbar>
		</AppBar>
	)
}

//TODO - Fix this static value
const drawerWidth = 81;

const useStyles = makeStyles((theme) => ({
	gridContainer: {
		padding: '0px 32px'
	},
	appBar: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: drawerWidth,
		boxShadow: "0px 1px 1px -2px rgba(0,0,0,0.2), 0px -1px 1px 1px rgba(0,0,0,0.05), 0px 3px 1px 3px rgba(0,0,0,0.01)",
		height: "62px",
		backgroundColor: "#FFFFFF",
	},
	toolbar: {
		height: "62px",
		padding: "0",
	},
}))

export default Cabecalho
